import React from 'react'
import ReactHtmlParser from 'react-html-parser'

interface RichTextViewerProps {
  richText: string
}

export const RichTextViewer: React.FC<RichTextViewerProps> = ({ richText }) => {
  return <div css={{ wordWrap: 'normal' }}>{ReactHtmlParser(richText)}</div>
}
